<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="currentVisible"
    width="600px"
    @close="handleClose"
    :before-close="handleBeforeClose"
    :close-on-click-modal="true"
    :close-on-press-escape="true"
    custom-class="custom-dialog"
  >
    <el-form :model="form" label-width="100px" ref="formRef" :rules="formRules">
      <!-- 时限选择 -->
      <el-form-item label="下线时限" prop="duration">
        <el-select v-model="form.duration" placeholder="请选择下线时限" style="width: 100%">
          <el-option
            v-for="option in durationOptions"
            :key="option.value"
            :label="option.label"
            :value="option.value"
          />
        </el-select>
      </el-form-item>

      <!-- 原因输入 -->
      <el-form-item label="下线原因" prop="reason">
        <el-input
          v-model="form.reason"
          type="textarea"
          placeholder="请输入下线原因（选填）"
          :maxlength="200"
          show-word-limit
          rows="4"
        />
      </el-form-item>
    </el-form>

    <!-- 弹窗底部按钮 -->
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitForm" :loading="submitLoading" class="submit-btn">确认下线</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {offlineConsultant} from '@/api/consultingService'

export default {
  name: 'OfflineDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    consultantId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      currentVisible: this.visible,
      submitLoading: false,

      // 表单数据
      form: {
        duration: '', // 下线时限
        reason: '' // 下线原因
      },

      // 时限选项
      durationOptions: [
        {label: '1天', value: 1},
        {label: '2天', value: 2},
        {label: '3天', value: 3},
        {label: '1周', value: 7},
        {label: '2周', value: 14},
        {label: '1个月', value: 30},
        {label: '2个月', value: 60},
        {label: '3个月', value: 90},
        {label: '半年', value: 182},
        {label: '1年', value: 365},
        {label: '2年', value: 730},
        {label: '3年', value: 1095},
        {label: '5年', value: 1825},
        {label: '10年', value: 3650},
        {label: '永久', value: -1}
      ],
      // 表单校验规则
      formRules: {
        duration: [{required: true, message: '请选择下线时限', trigger: 'change'}],
        reason: [{max: 200, message: '原因不能超过200字', trigger: 'blur'}]
      }
    }
  },
  computed: {
    // 弹层标题（带图标）
    dialogTitle() {
      return '下线'
    }
  },
  watch: {
    visible(newVal) {
      this.currentVisible = newVal
      if (newVal) {
        this.resetForm()
      }
    },
    currentVisible(newVal) {
      if (newVal !== this.visible) {
        this.$emit('update:visible', newVal)
      }
    }
  },
  methods: {
    /**
     * 提交表单
     */
    async submitForm() {
      this.$refs.formRef.validate(async isValid => {
        if (!isValid) return

        this.submitLoading = true
        try {
          // 构建提交数据
          const submitData = {
            consultantId: this.consultantId,
            action: 'offline',
            offlineDays: this.form.duration,
            reason: this.form.reason || '' // 如果为空则不传该字段
          }

          // 调用下线接口
          const res = await offlineConsultant(submitData)

          if (res.code === 200) {
            this.$message.success('下线成功')
            this.$emit('offline-success')
            this.handleClose()
          } else {
            this.$message.error(res.msg || '下线失败，请重试')
          }
        } catch (error) {
          console.error('下线操作失败:', error)
          this.$message.error('操作失败，请重试')
        } finally {
          this.submitLoading = false
        }
      })
    },

    /**
     * 重置表单
     */
    resetForm() {
      this.form = {
        duration: '',
        reason: ''
      }
      this.submitLoading = false
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate()
      })
    },

    /**
     * 处理弹窗关闭
     */
    handleClose() {
      this.currentVisible = false
      this.$emit('close')
    },

    /**
     * 弹窗关闭前处理
     */
    handleBeforeClose(done) {
      if (this.submitLoading) {
        this.$message.warning('正在处理中，请稍候...')
        return
      }
      done()
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .custom-dialog {
  border-radius: 12px;
  overflow: hidden;

  .el-dialog__header {
    padding: 24px 40px 20px;
    border-bottom: none;

    .el-dialog__title {
      font-size: 20px;
      font-weight: 600;
      color: #333;
      display: flex;
      align-items: center;
      gap: 8px;

      &::before {
        content: '';
        display: inline-block;
        width: 24px;
        height: 24px;
        background-image: url('/img/xiaxian.png');
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
      }
    }

    .el-dialog__headerbtn {
      top: 24px;
      right: 40px;
    }
  }

  .el-dialog__body {
    padding: 24px 60px;
  }

  .el-dialog__footer {
    padding: 20px 40px 32px;
    border-top: none;
  }

  .el-form {
    .el-form-item {
      margin-bottom: 24px;

      .el-form-item__label {
        font-size: 16px;
        color: #333;
        font-weight: 500;
        padding-bottom: 8px;
        text-align: left;
      }

      .el-form-item__content {
        .el-select,
        .el-input,
        .el-textarea {
          width: 100%;
        }
      }
    }
  }
}

.dialog-footer {
  text-align: center;
  padding: 0;

  .submit-btn {
    width: 60%;
    height: 48px;
    font-size: 18px;
    font-weight: 500;
    border-radius: 8px;
    background: #5ad3cd;
    border-color: #5ad3cd;

    &:hover {
      background: #4ab8b2;
      border-color: #4ab8b2;
    }
  }
}

/deep/ .el-textarea__inner {
  resize: none;
}
</style>
